import React, { createRef, Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/StyledButton/StyledButton';

import CustomGreenButton from '../../../../../../common/styled/CustomGreenButton/CustomGreenButton';
import api from '../../../../../../utils/api';

interface Props {
    id: number;
    companyId: number;
    assessmentId: number;
    isApproved: boolean;
    minimumWidth: number;
    setMinimumWidth: Dispatch<SetStateAction<number>>;
}

const ApproveButton = (props: Props) => {
    const { id, companyId, assessmentId, isApproved: initialIsApproved, minimumWidth, setMinimumWidth } = props;

    const [isApproved, setIsApproved] = useState(initialIsApproved);
    const [hasOver, setHasOver] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { t } = useTranslation();

    const mouseMoveRef = createRef<HTMLButtonElement>();

    const label = useMemo(() => {
        return t('pages.plastic_assessment.tabs.kpi.table.' + (isApproved ? '' : 'not_') + 'approved');
    }, [isApproved, t]);

    const labelHover = useMemo(() => {
        return t('pages.plastic_assessment.tabs.kpi.table.' + (isApproved ? 'dis' : '') + 'approve');
    }, [isApproved, t]);

    const checkHover = useCallback((e: any) => {
        if (mouseMoveRef.current) {
            // @ts-ignore
            const mouseOver = mouseMoveRef.current.contains(e.target);

            if (mouseOver) {
                setHasOver(true);
            } else {
                setHasOver(false);
            }
        }
    }, [mouseMoveRef]);

    const handleClick = useCallback(() => {
        setIsLoading(true);
        api.request('/companies/' + companyId + '/plastic-assessments/' + assessmentId + '/kpis/' + id + '/approve', 'POST', { isApproved: !isApproved }).then((res) => {
            setIsApproved(res.isApproved);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [assessmentId, companyId, id, isApproved]);

    useEffect(() => {
        window.addEventListener('mousemove', checkHover, true);

        return () =>{
            window.removeEventListener('mousemove', checkHover, true);
        };
    }, [checkHover]);

    useEffect(() => {
        if (mouseMoveRef.current) {
            setMinimumWidth((w: any) => (mouseMoveRef?.current?.offsetWidth ?? 0) > w ? mouseMoveRef?.current?.offsetWidth : w);
        }
    }, [setMinimumWidth, mouseMoveRef, hasOver]);

    if ((isApproved && !hasOver) || (!isApproved && hasOver)) {
        return (
            <>
                <CustomGreenButton ref={mouseMoveRef} disabled={isLoading} variant={hasOver ? 'contained' : 'outlined'} color='primary' onClick={handleClick} style={{backgroundColor: hasOver ? undefined : '#ffffff', minWidth: minimumWidth + 'px'}}>
                    {hasOver ? labelHover : label}
                </CustomGreenButton>{' '}
            </>
        );
    } else {
        return (
            <>
                <Button ref={mouseMoveRef} disabled={isLoading} variant={hasOver ? 'contained' : 'outlined'} color='secondary' onClick={handleClick} style={{backgroundColor: hasOver ? undefined : '#ffffff', minWidth: minimumWidth + 'px'}}>
                    {hasOver ? labelHover : label}
                </Button>{' '}
            </>
        );
    }
};

export default ApproveButton;
